export const getCustomerOrderWidth = (screenWidth: number, marginAdjust = 0) => {
    const orderInRowCount = Math.floor(screenWidth / 175)

    return screenWidth / orderInRowCount - marginAdjust
}
